/* eslint-disable react/function-component-definition */
/* eslint-disable import/extensions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import styled from '@emotion/styled';
import { breakpoints, palette, Progress } from '@playdapp/ui';

import type { Step as StepInfo } from 'types/transactionModal';

import type { Icons } from '@/components/Icon';
import Icon from '@/components/Icon';

type Props = {
  step: number;
  stepBarSize: string;
  stepInfo: StepInfo[];
};

const StepBlock = styled.div<{ stepCount: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-right: 60px;

  ${breakpoints.down('lg')} {
    flex-direction: row;
    margin-right: 0;
    width: ${({ stepCount }) =>
      stepCount === 2 ? `40%` : stepCount === 3 ? '70%' : '100%'};
  }

  ${breakpoints.down('md')} {
    justify-content: space-between;
    width: ${({ stepCount }) => `${stepCount * 70}px`};
  }
`;

const StepBar = styled.div<{ position: string; size: string; color: string }>`
  position: absolute;
  top: ${({ position }) => position};
  left: 50%;
  height: ${({ size }) => size};
  border: 0.5px solid ${({ color }) => color};

  ${breakpoints.down('lg')} {
    flex-direction: row;
    top: 50%;
    left: ${({ position }) => position};
    height: auto;
    width: ${({ size }) => size};
  }
`;

const Stepper = styled.div<{ stepCount: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  img {
    z-index: 1;
  }

  .spinner {
    position: absolute;
    width: 54px;
    height: 54px;

    * {
      width: 100%;
      height: 100%;
    }
  }

  & + & {
    margin-top: ${({ theme }) => theme.rem(40)};

    ${breakpoints.down('lg')} {
      margin-top: 0;
      margin-left: ${({ theme }) => theme.rem(87)};
    }

    ${breakpoints.down('md')} {
      margin-left: ${({ stepCount }) =>
        stepCount === 2 ? 'calc(80% - 50px)' : 'calc(33% - 50px)'};
    }
  }
`;

const Step = ({ step, stepBarSize, stepInfo }: Props) => (
  <StepBlock stepCount={stepInfo.length}>
    <StepBar position="0" size={stepBarSize} color={palette.primary600} />
    <StepBar
      position={stepBarSize}
      size={`calc(100% - ${stepBarSize})`}
      color={palette.gray600}
    />
    {stepInfo.map((item, idx) => {
      const active = idx + 1 === step;
      let iconName = step > idx + 1 ? 'check' : item.icon;

      if (
        iconName !== 'check' &&
        iconName !== 'initialize' &&
        iconName !== 'unlock-gray' &&
        iconName !== 'approve-gray' &&
        iconName !== 'complete-gray' &&
        step < idx + 1
      ) {
        iconName = `${iconName}-gray`;
      }

      return (
        <Stepper
          key={`transaction-modal-step-${idx}`}
          stepCount={stepInfo.length}
        >
          <Icon name={iconName as Icons} size="40px" />
          {active && (
            <div className="spinner">
              <Progress type="grow" color={palette.primary600} />
            </div>
          )}
        </Stepper>
      );
    })}
  </StepBlock>
);

export default Step;
